import { render } from "./AddVehicle.vue?vue&type=template&id=0725f54c"
import script from "./AddVehicle.vue?vue&type=script&lang=js"
export * from "./AddVehicle.vue?vue&type=script&lang=js"

import "./AddVehicle.vue?vue&type=style&index=0&id=0725f54c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__